import { Card, Checkbox, Form, Title } from 'components/common'

export interface AdminOnlyReservationProps {
  isAdminOnlyReservation?: boolean
  loading?: boolean
}

export interface AdminOnlyReservationFromValues {
  isAdminOnlyReservation: boolean
}

export const AdminOnlyReservation = ({
  isAdminOnlyReservation,
  loading = false,
}: AdminOnlyReservationProps): JSX.Element => (
  <Card shadow loading={loading}>
    <Title level={5}>管理者のみ予約可能かどうか</Title>

    <Form.Item
      name="adminOnlyReservation"
      initialValue={isAdminOnlyReservation}
      valuePropName="checked"
      noStyle
    >
      <Checkbox>この施設は管理者のみ予約可能です。</Checkbox>
    </Form.Item>
  </Card>
)
